module.exports = {
  toBrailleText: require('./toBraille'),
  toAlphabetText: require('./toAlphabet'),
  ascii: require('./ascii'),
}
